import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS } from '../actions/work_order_priorities_actions';

export const workOrderPrioritiesRestCrudThunks = (userType) =>
	userType === ROLE_TYPES.SUPPLIER
		? workOrderPrioritiesRestCrudThunksForSupplier
		: workOrderPrioritiesRestCrudThunksForBuyer;

export const workOrderPrioritiesRestCrudThunksForBuyer = new RestCrudThunks(
	'work_order_priorities',
	'work_order_priority',
	'workOrderPriority',
	'workOrderPriorities',
	WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const workOrderPrioritiesRestCrudThunksForSupplier = new RestCrudThunks(
	'work_order_priorities',
	'work_order_priority',
	'workOrderPriority',
	'workOrderPriorities',
	WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);

export const workOrderPrioritiesWithoutPMRestCrudThunksForBuyer = new RestCrudThunks(
	'work_order_priorities_without_pm',
	'work_order_priority',
	'workOrderPriority',
	'workOrderPriorities',
	WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const workOrderPrioritiesWithoutPMRestCrudThunksForSupplier = new RestCrudThunks(
	'work_order_priorities_without_pm',
	'work_order_priority',
	'workOrderPriority',
	'workOrderPriorities',
	WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);
